import { useMateCountersStore } from "~/stores/user/mateCounters";

/**
 * Loads the professional's job-feed counters before a job-feed page renders,
 * on the server for a full page load and on the client for a navigation.
 */
export default async function mateCountersMiddleware({ $pinia }) {
  await useMateCountersStore($pinia).load();
}
